import { useFormik } from "formik";
import { convertToFilter, makeObservable } from "../../../util";
import { useEffect } from "react";

const reservationFilterStore = makeObservable({});

const useReservationFilters = () => {
  const formik = useFormik({
    initialValues: {
      categoryId: "",
      type: { operator: "in" },
    },
  });

  const filterKeys = [];

  const skipKeys = ["limit", "offset"];

  useEffect(() => {
    reservationFilterStore.set(
      convertToFilter({ values: formik.values, filterKeys, skipKeys }),
    );
  }, [formik.values]);

  return {
    formik,
  };
};

export { reservationFilterStore, useReservationFilters };
